export default __webpack_public_path__ + "static/media/hackathon_transparent.a29282fb.webp";